<template>
  <q-chip
    class="q-ml-none q-mb-none"
    :color="color"
    :dense="dense"
    :outline="outline"
    :removable="removable"
    size="md"
    :tabindex="tabindex"
    @remove="$emit('remove', $event)"
  >
    <TagAvatar :size="dense ? 'xs' : 'sm'" :tag="tag" />
    {{ tag.value }}
  </q-chip>
</template>

<script>
import TagAvatar from 'components/tags/TagAvatar';

export default {
  name: 'TagChip',
  props: {
    color: String,
    dense: {
      type: Boolean,
      default: false,
    },
    outline: {
      type: Boolean,
      default: true,
    },
    removable: {
      type: Boolean,
      default: false,
    },
    tabindex: Number,
    tag: {
      type: Object,
    },
  },
  components: {
    TagAvatar,
  },
};
</script>
